var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypageCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/General/Card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.183 4.66612L11.9989 4.49982L4.81482 4.66612C3.36307 4.69563 2.13232 5.74215 1.86984 7.17028C1.28297 10.3634 1.28297 13.6367 1.86984 16.8298C2.13232 18.2579 3.36307 19.3044 4.81482 19.3339L11.9989 19.5002L19.183 19.3339C20.6348 19.3044 21.8655 18.2579 22.128 16.8298C22.7149 13.6367 22.7149 10.3634 22.128 7.17028C21.8655 5.74215 20.6348 4.69563 19.183 4.66612ZM20.9989 11C20.9989 11.5523 20.5512 12 19.9989 12H3.9989C3.44662 12 2.9989 11.5523 2.9989 11C2.9989 10.4477 3.44662 10 3.9989 10H19.9989C20.5512 10 20.9989 10.4477 20.9989 11Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageCard);
export default __webpack_public_path__ + "static/media/mypage_card.86ebf088346ffe1e97cd88256f5cf0c3.svg";
export { ForwardRef as ReactComponent };